import { createFileRoute, useNavigate } from '@tanstack/react-router'
import React from 'react'
import InvoicesModal from '../../../components/modals/InvoicesModal'
import { useAuth } from '../../../contexts/AuthContext'
import { useClientProfile } from '../../../hooks/useClientProfile'
import { AppLayout } from '../../../components/layouts/AppLayout'

export const Route = createFileRoute('/billing/invoices')({
  component: InvoicesPage,
})

function InvoicesPage() {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const clientQuery = useClientProfile(currentUser?.email)

  const handleClose = () => {
    navigate({ to: '/campaigns' })
  }

  return (
    <AppLayout
      currentView="campaigns"
      aiCredits={clientQuery.data?.credits ?? 0}
      creditsLoading={clientQuery.isPending}
      clientInfo={clientQuery.data}
    >
      <InvoicesModal isOpen={true} onClose={handleClose} />
    </AppLayout>
  )
}
